import Api from './api';

// ========== Applications ==========
export const getApplications = () => {
    return Api.get('/applications');
};

export const getApplicationById = (id) => {
    return Api.get(`/applications/${id}`);
};

export const createApplication = (data) => {
    const formData = new FormData();
    formData.append('Name', data.name);
    formData.append('IsProduct', data.isProduct);
    return Api.post('/applications', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const updateApplication = (data) => {
    const formData = new FormData();
    formData.append('Id', data.id);
    formData.append('Name', data.name);
    formData.append('IsProduct', data.isProduct);
    return Api.put('/applications', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const deleteApplication = (id) => {
    return Api.delete(`/applications/${id}`);
};

// ========== Features ==========
export const getFeatures = () => {
    return Api.get('/features');
};

export const getFeaturesByApplicationId = (applicationId) => {
    return Api.get(`/subscription/features-by-application/${applicationId}`);
};

export const getFeatureById = (id) => {
    return Api.get(`/features/${id}`);
};

export const createFeature = (data) => {
    const formData = new FormData();
    formData.append('Name', data.name);
    formData.append('ApplicationId', data.applicationId);
    if (data.userLimit != null) formData.append('UserLimit', data.userLimit);
    formData.append('MostChosed', data.mostChosed || false);
    return Api.post('/features', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const updateFeature = (data) => {
    const formData = new FormData();
    formData.append('Id', data.id);
    formData.append('Name', data.name);
    formData.append('ApplicationId', data.applicationId);
    if (data.userLimit != null) formData.append('UserLimit', data.userLimit);
    formData.append('MostChosed', data.mostChosed || false);
    return Api.put('/features', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const deleteFeature = (id) => {
    return Api.delete(`/features/${id}`);
};

// ========== Plan Features ==========
export const getPlanFeatures = () => {
    return Api.get('/planfeatures');
};

export const getPlanFeatureById = (id) => {
    return Api.get(`/planfeatures/${id}`);
};

export const createPlanFeature = (data) => {
    const formData = new FormData();
    formData.append('PlanId', data.planId);
    formData.append('FeatureId', data.featureId);
    formData.append('FeaturePrice', data.featurePrice);
    return Api.post('/planfeatures', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const updatePlanFeature = (data) => {
    const formData = new FormData();
    formData.append('Id', data.id);
    formData.append('PlanId', data.planId);
    formData.append('FeatureId', data.featureId);
    formData.append('FeaturePrice', data.featurePrice);
    return Api.put('/planfeatures', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const deletePlanFeature = (id) => {
    return Api.delete(`/planfeatures/${id}`);
};
